<template>
  <el-main
    class="login-container"
    v-loading.body="isSubmitting"
    :element-loading-text="$t('Submitting...')">
    <el-row class="login-page" type="flex" justify="center" align="middle">
      <el-col :span="12" class="splash-holder">
        <div class="splash">
          <!--<img src="@/assets/images/logo_scb-wh.png" alt="SCB Payin Slip" class="logo">-->
          <h1 class="title">BP Payin Slip</h1>
          <h2 class="subtitle">{{ appName | translate }}</h2>
        </div>
        <div class="footer">
          <code class="app-env">
            env: {{ $scbAppInfo.env }}<br/>
            mode: {{ $scbAppInfo.mode }}<br/>
            build: {{ $scbAppInfo.build }}<br/>
            version: {{ $scbAppInfo.version }}</code>
          <!--<div class="copy">
            &copy; Copyright {{ currentYear }} The Siam Commercial Bank Public Company Limited. All right reserved.<br/>
            <div class="help-desk-contact">
              Need support on problem or question? <a href="#">Contact SCB help desk.</a>
            </div>
          </div>-->
        </div>
      </el-col>
      <el-col :span="12">
        <el-row type="flex" justify="left" align="middle">
          <el-col :span="12" :offset="3" class="form-holder">
            <div class="forgot-password-form-holder">
              <h2>เปลี่ยนรหัสผ่านใหม่</h2>
              <el-form
                :model="resetPasswordModel"
                :rules="rules"
                ref="resetPasswordModel"
                label-width="120px"
                class="reset-password-form"
                label-position="top"
                @submit.native.prevent="submitForm('resetPasswordModel')">
                <el-form-item label="รหัสผ่านใหม่" prop="password">
                  <el-input
                    v-model="resetPasswordModel.password"
                    id="resetPasswordModel-password"
                    placeholder="กรอกรหัสผ่านของท่าน"
                    type="password"
                    :autofocus="true"
                    suffix-icon="el-icon-star-off"></el-input>
                </el-form-item>
                <el-form-item label="ยืนยันรหัสผ่านใหม่" prop="passwordRepeat">
                  <el-input
                    v-model="resetPasswordModel.passwordRepeat"
                    id="resetPasswordModel-password-repeat"
                    placeholder="กรอกรหัสผ่านของท่านอีกครั้ง"
                    type="password"
                    suffix-icon="el-icon-star-off"></el-input>
                </el-form-item>
                <div class="reset-password-instruction">
                  <ul>
                    <li>ใช้อักษรอังกฤษเท่านั้น ต้องมี อย่างน้อย</li>
                    <li>1 ตัวเลข</li>
                    <li>1 ตัวพิมพ์ใหญ่</li>
                    <li>1 ตัวพิมพ์เล็ก</li>
                    <li>ความยาว 8 ตัวขึ้นไป</li>
                    <li>อักขระพิเศษใส่ได้ยกเว้น space</li>
                  </ul>
                </div>
                <el-form-item>
                  <el-button type="primary" plain class="cancel-reset-password-btn" @click.prevent="cancel">{{ $t('Cancel') }}</el-button>
                  <el-button type="primary" id="resetPasswordModel-submitButton" native-type="submit">{{ 'Confirm' | translate }}</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-main>
</template>

<script>
import moment from 'moment-timezone';
import HttpClient from '@/libs/http';
import XRegExp from 'xregexp';

/**
 * ResetPassword view
 */
const ResetPasswordWithToken = {
  name: 'reset-password-with-token',
  // props: ['resetPasswordToken'],
  data() {
    return {
      isSubmitting: false,
      errorMessage: '',
      submitError: '',
      resetPasswordModel: {
        password: '',
        passwordRepeat: '',
      },
      rules: {
        password: [
          { required: true, message: this.$t('Please input password'), trigger: 'blur' },
          {
            type: 'string',
            pattern: new XRegExp('^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])([^\\s]){8,}$', 'g'),
            message: 'กรุณากรอกรหัสผ่านให้ถูกต้องตามรูปแบบที่ระบุไว้',
          },
          { validator: this.checkPassword, message: this.$t('Please input password is not matched'), trigger: 'blur' },
        ],
        passwordRepeat: [
          { required: true, message: this.$t('Please input password again'), trigger: 'blur' },
          { validator: this.confirmPassword, message: this.$t('Please input password is not matched'), trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    needResetPwd() {
      return this.$store.getters.needResetPwd;
    },
    currentYear() {
      const now = new Date();
      return now.getFullYear();
    },
    appName() {
      return this.$store.getters.appName;
    },
    resetPasswordToken() {
      return this.$route.query.rstToken
    }
  },
  methods: {
    checkPassword(rule, value, cb) {
      if (this.resetPasswordModel.passwordRepeat !== '') {
        this.$refs.resetPasswordModel.validateField('passwordRepeat');
        cb();
      }
    },
    confirmPassword(rule, value, cb) {
      if (value !== this.resetPasswordModel.password) {
        cb(new Error('Two inputs don\'t match!'));
      } else {
        cb();
      }
    },
    validateForm(valid) {
      if (!valid) {
        this.$log.error('error submit!!');
        return false;
      }
      this.isSubmitting = true;
      const payload = {
        force: false,
        token: this.resetPasswordToken,
        password: this.resetPasswordModel.password,
      };
      this.$store.dispatch('CHANGE_PASSWORD', payload).then(() => {
        this.isSubmitting = false;
        // we're good. now redirect to default page
        this.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: this.$t('Successfully changed your password.'),
        });
        const defaultRouteName = window.appConfig.SCB_BILLING_APP_MODE === 'admin' ?
          process.env.DEFAULT_ROUTE_NAME : process.env.DEFAULT_BILLER_ROUTE_NAME;
        this.$router.push({ name: defaultRouteName });
      }).catch((msg) => {
        this.isSubmitting = false;
        if (msg) {
          this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
        } else {
          this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
        }
      });
      return true;
    },
    submitForm(formName) {
      this.errorMessage = '';
      this.$refs[formName].validate(this.validateForm);
      return false;
    },
    cancel() {
      this.$router.push({ name: 'Login' });
    },
  },
  created() {
    // check if user want to reset password with the valid token
    if (this.resetPasswordToken) {
      let isValid = false;
      // we have to verify token first
      const $http = new HttpClient();
      const expDate = $http.getTokenExpirationDate(this.resetPasswordToken);
      if (expDate) {
        // invalid token
        const now = moment().tz(process.env.DEFAULT_TZ);
        if (expDate.diff(now) > 0) {
          isValid = true;
        }
      }
      if (!isValid) {
        alert("ลิงค์เปลี่ยนรหัสนี้หมดอายุแล้ว กรุณากดเปลี่ยนรหัสเพื่อรับลิงค์ใหม่อีกครั้ง (ที่หน้า Login)")
        this.$router.push({ name: 'Login' });
      }
    }
  },
};
export default ResetPasswordWithToken;
</script>

<style lang="scss" scoped>
@import '../../assets/styles/pages/auth-page';
</style>



// WEBPACK FOOTER //
// src/pages/auth/reset-password-with-token.vue